import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useRequestsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemServiceProviderAuth */
  const menuItemServiceProviderAuth = {
    id: "serviceProviderAuth",
    title: t("Modules.ServiceProviderAuth.serviceProviderAuth"),
    url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_AUTH),
  };
  tempMenuGroup.push(menuItemServiceProviderAuth);
  /* menuItemServiceProviderAuth */

  /* menuItemLoginAuth */
  const menuItemLoginAuth = {
    id: "loginAuth",
    title: t("Modules.ServiceProviderAuth.doctorAuth"),
    url: baseRouteMakerForSuperAdmin(routes.LOGIN_AUTH),
  };
  tempMenuGroup.push(menuItemLoginAuth);
  /* menuItemLoginAuth */

  return tempMenuGroup;
};
